import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import signup from '@/components/page/signup'

Vue.use(Router)

export default new Router({
  // mode:"history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js